import getPublicFileUrl from "./getPublicFileUrl.js";

const url = location.origin + location.pathname.replace(/\/[^/]+.html?/, '/report.html');

export default function (params) {
    const query = [];

    for (let key in params) {
        query.push(`${key}=${encodeURIComponent(encodeURIComponent(params[key]))}`);
    }

    return {
        title: "家庭保障报告",
        content: "家庭保障报告",
        url: `${url}?${query.join("&")}`,
        image: getPublicFileUrl("/share-icon.png")
    };
}